<template>
    <div>
        <b-row>
            <b-col cols="12" md="12">
                <app-form-text-input
                    label="Titulo"
                    id="title"
                    :required="true"
                    :hasError="$v.theAlert.title.$error"
                    errorMessage="Debe escribir el titulo de la alerta"
                    @input="$v.theAlert.title.$touch()"
                    v-model="theAlert.title"
                />
            </b-col>
            <b-col cols="12" md="12">
                <app-form-textarea-input
                    label="Descripción"
                    id="description"
                    v-model="theAlert.description"
                />
            </b-col>
            <b-col cols="12" md="6">
                <div class="form-group">
                    <label for="">Fecha de inicio</label>
                    <app-datepicker
                        class="form-control"
                        v-model="startDate"
                        id="startDate"
                        :format="customFormatter"
                        :language="es"
                    />
                </div>
            </b-col>
            <b-col cols="12" md="6">
                <div class="form-group">
                    <label for="">Fecha de finalización</label>
                    <app-datepicker
                        class="form-control"
                        v-model="endDate"
                        id="endDate"
                        :format="customFormatter"
                        :language="es"
                    />
                </div>
            </b-col>
            <b-col cols="12" md="6">
                <div class="form-group">
                    <label for=""
                        >Perfiles
                        <span class="field-required-mark">*</span></label
                    >
                    <b-form-select
                        multiple
                        :select-size="4"
                        v-model="profilesSelected"
                        @change="$v.profilesSelected.$touch()"
                        :options="profiles"
                        class="mb-3"
                    />
                    <div>
                        Seleccionados:
                        <strong>{{ profilesSelected.length }}</strong>
                    </div>
                    <span
                        class="field-error"
                        v-if="!!$v.profilesSelected.$error"
                        >Debe seleccionar minimo un perfil</span
                    >
                </div>
            </b-col>
            <b-col cols="12" md="6">
                <div class="form-group">
                    <label for=""
                        >Ciudades
                        <span class="field-required-mark">*</span></label
                    >
                    <b-form-select
                        multiple
                        :select-size="4"
                        v-model="citiesSelected"
                        @change="$v.citiesSelected.$touch()"
                        :options="cities"
                        class="mb-3"
                    />
                    <div>
                        Seleccionados:
                        <strong>{{ citiesSelected.length }}</strong>
                    </div>
                    <span class="field-error" v-if="!!$v.citiesSelected.$error"
                        >Debe seleccionar minimo una ciudad</span
                    >
                </div>
            </b-col>
            <b-col>
                <b-card tag="article" style="max-width: 100%;" class="mb-2">
                    <div class="card-text">
                        <h4>
                            Foto de la alerta
                            <span class="field-required-mark">*</span>
                        </h4>
                        <b-form-file
                            required
                            v-model="theAlert.file"
                            :state="Boolean(theAlert.file)"
                            placeholder="Seleccione imagen de la alerta"
                            accept=".jpg, .jpeg, .png, .pdf"
                            ref="fileinput"
                        ></b-form-file>
                        <div v-if="theAlert.file" class="mt-3">
                            Archivo seleccionado:
                            {{ theAlert.file && theAlert.file.name }}
                        </div>
                        <span
                            class="field-error"
                            v-if="!!$v.theAlert.file.$error"
                            >Debe seleccionar un archivo</span
                        >
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import comunicationsRepository from '../../../../repositories/comunications.repository'
import usersRepository from '../../../../repositories/users.repository'
import localizationRepository from '../../../../repositories/localizationRepository'
import { required } from 'vuelidate/lib/validators'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import UploadOrTakePhoto from '../../../UI/Controls/Photos/UploadOrTakePhoto.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        appDatepicker: Datepicker,
        appUploadOrTakePhoto: UploadOrTakePhoto,
    },

    props: {
        onSave: {
            type: Function,
        },
    },

    data() {
        return {
            theAlert: {
                createdById: '',
                title: '',
                description: '',
                startDate: '',
                endDate: '',
                profiles: '',
                cities: '',
                file: null,
            },
            profilesSelected: [],
            citiesSelected: [],
            startDate: '',
            endDate: '',
            es: es,
        }
    },

    validations: {
        theAlert: {
            title: { required },
            file: { required },
        },
        profilesSelected: { required },
        citiesSelected: { required },
    },

    watch: {
        startDate(val) {
            this.theAlert.startDate = moment(val).format('DD/MM/YYYY')
        },
        endDate(val) {
            this.theAlert.endDate = moment(val).format('DD/MM/YYYY')
        },
    },
    computed: {
        ...mapGetters({
            theProfiles: 'profiles',
            theCities: 'cities',
        }),
        profiles() {
            return this.theProfiles.map(item => ({
                value: item.slug,
                text: item.name,
            }))
        },
        cities() {
            return this.theCities.map(item => ({
                value: item.slug,
                text: item.name,
            }))
        },
    },
    methods: {
        saveAlertNotification() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            this.fillProfiles()
            this.fillCities()

            const formData = new FormData()

            const _d = d => moment(d, 'DD/MM/YYYY').format('YYYY-MM-DD')

            formData.append('createdById', this.user.id)
            formData.append('title', this.theAlert.title)
            formData.append('description', this.theAlert.description)
            formData.append('startDate', _d(this.theAlert.startDate))
            formData.append('endDate', _d(this.theAlert.endDate))
            formData.append('profiles', this.theAlert.profiles)
            formData.append('cities', this.theAlert.cities)

            if (this.theAlert.file) {
                formData.append('file', this.theAlert.file)
            }

            const cr = { ...comunicationsRepository }
            cr.saveAlert(formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        typeof this.onSave === 'function' && this.onSave()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al guardar la notificación de alerta'
                    )
                })
        },
        customFormatter(date) {
            return moment(date).format('DD/MM/YYYY')
        },
        fillProfiles() {
            if (this.profilesSelected.length) {
                this.profilesSelected.map(item => {
                    if (this.theAlert.profiles == '') {
                        this.theAlert.profiles = item
                    } else {
                        this.theAlert.profiles =
                            this.theAlert.profiles + ',' + item
                    }
                })
            }
        },
        fillCities() {
            if (this.citiesSelected.length) {
                this.citiesSelected.map(item => {
                    if (this.theAlert.cities == '') {
                        this.theAlert.cities = item
                    } else {
                        this.theAlert.cities = this.theAlert.cities + ',' + item
                    }
                })
            }
        },
        cleanFields() {
            this.startDate = ''
            this.endDate = ''
            this.citiesSelected = []
            this.profilesSelected = []
            this.$refs['fileinput'].reset()
            Object.keys(this.theAlert).map(
                key => key !== 'file' && (this.theAlert[key] = '')
            )
            this.theAlert.file = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        initialize() {
            this.load('profiles')
            this.load('cities')
        },
    },
    created() {
        this.initialize()
        this.$bus.$on(
            'alert-notification-form.save',
            this.saveAlertNotification
        )
        this.$bus.$on('alert-notification-form.clean', this.cleanFields)
    },
    beforeDestroy() {
        this.$bus.$off('alert-notification-form.save')
    },
}
</script>

<style>
#startDate,
#endDate {
    width: 100%;
    border-color: transparent transparent;
}

.custom-file-input:lang(es) ~ .custom-file-label::after {
    content: 'Buscar';
}
</style>
